export default {"src":"/_next/static/media/logo.420aca50.svg","height":339,"width":1123,"blurWidth":0,"blurHeight":0};